/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export class VideoStreamingState {
    static STREAMING_STATE_PREFLIGHT = 'preflight';

    static STREAMING_STATE_STARTING = 'videoStarting';

    static STREAMING_STATE_STREAMING = 'videoStreaming';
}
